import helper from "@/utils/helper";
import { aliases } from "browserslist";

export default (theme) => ({
  fees: {
    marginLeft: "8px",
  },
  gridWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    height: 64,
    padding: "0 32px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.commonBg,
    position: "fixed",
    width: "100%",
    zIndex: 2,
  },

  logo: {
    margin: "0 24px 0 0",
    "& img": {
      // width: 110,
      height: 24,
      display: "block",
    },
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: 24,
  },
  footer: {
    width: "100%",
    padding: "200px 0 40px",
    background: helper.hex_to_rgba(theme.palette.grey[10], 0.2),
  },
  footer_con: {
    display: "flex",
    justifyContent: "space-between",
    width: 1200,
    minHeight: 306,
    margin: "0 auto",
    color: theme.palette.text[60],

    "& a": {
      color: theme.palette.text[60],
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    "& .item1": {
      "& img": {
        // width: 110,
        height: 24,
        display: "block",
        margin: "0 0 20px",
      },
      "& > div": {
        margin: "0 0 20px",
      },
      "& p": {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "21px",
        margin: "0 0 12px",
      },
      "& a": {
        fontSize: 14,
        lineHeight: "24px",
        color: theme.palette.primary.main,
        display: "flex",
        margin: "0 0 6px",
      },
      "& a.download": {
        background: theme.palette.primary.main,
        width: 150,
        height: 38,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14,
        fontWeight: 700,
        color: "#fff",
        borderRadius: 4,
        "&:hover": {
          color: theme.palette.primary[20],
        },
        "&:active": {
          color: theme.palette.primary[50],
          background: theme.palette.primary.m50,
        },
      },
    },
    "& .item2": {
      "& h2": {
        color: theme.palette.text[100],
        lineHeight: "24px",
        fontSize: 16,
        fontWeight: 500,
        margin: "0 0 28px",
      },
      "& a": {
        color: theme.palette.text[60],
        display: "block",
        lineHeight: "21px",
        margin: "0 0 18px",
        fontSize: 14,
        cursor: "pointer",
        "&:hover": {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  medias: {
    gap: 13,
    margin: "6px 0 0",
    width: 160,
    "& img": {
      transition: "all .3s ease-in-out",
      "&:hover": {
        transform: "scale(1.2,1.2)",
      },
    },
    "& a": {
      color: `${theme.palette.text[60]} !important`,
      transition: "all .3s ease-in-out",
      "&:hover": {
        color: `${theme.palette.text[100]} !important`,
        transform: "scale(1.2,1.2)",
      },
    },
  },
  media_tele: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    background: theme.palette.primary.main,
    boxShadow: "0px 4px 5.3px 0px #DECCFC",
    borderRadius: 24,
  },
  media_x: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    background: theme.palette.grey[10],
    boxShadow: "0px 4px 5.3px 0px #9797971A",
    borderRadius: 24,
    "& svg": {
      "& path": {
        fill: theme.palette.grey.black,
      },
    },
  },
  media_x_night: {},
  footer_con2: {
    margin: "88px 0 0",
    color: theme.palette.text[25],
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "16px",
    display: "flex",
    justifyContent: "center",
    gap: 100,
  },

  unlogin: {
    display: "flex",
    alignItems: "center",
    gap: 24,
  },
  loged: {
    display: "flex",
    alignItems: "center",
    gap: 24,
  },
  greybtn: {
    borderRadius: 8,
    background: "#3D3E49",
    color: "#F0F2F5",
    "&:hover": {
      background: "#3D3E49",
      opacity: 0.9,
      color: "#F0F2F5",
    },
  },
  small_btn: {
    padding: "0 20px",
    height: 30,
    fontSize: 14,
  },
  login_btn: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text[100],
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  register_btn: {
    fontWeight: 500,
    borderRadius: 8,
  },
  header_svg: {
    height: 24,
    height: 24,
    cursor: "pointer",
    color: theme.palette.text[100],
    "&:hover": {
      svg: {
        color: theme.palette.primary.main,
      },
    },
  },
  g_svg_stroke: {
    stroke: "currentColor !important",
  },
  header_popover_btn: {
    position: "relative",
    "& .header_popover": {
      position: "absolute",

      flexDirection: "column",
      alignItems: "flex-start",
      padding: 24,

      transition: "all .3s ease-in-out",
      background: theme.palette.grey.white,
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.05)",
      borderRadius: 8,
      display: "none",
      height: 0,
    },
    // "&:hover": {
    //   "& .header_popover": {
    //     display: "flex",
    //     height: "auto",
    //   },
    // },
  },
  showPopover: {
    display: "flex !important",
    height: "auto !important",
  },
  header_popover_message: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    minWidth: 180,
    fontSize: 14,
    "& ul": {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      padding: "0 0 0 24px",
    },
    "& li": {
      listStyle: "disc",
      width: 300,
      "&:hover": {
        "&::marker": {
          color: theme.palette.primary.main,
        },
      },
    },
    "& a": {
      color: theme.palette.text[100],
      lineHeight: "21px",
      display: "block",
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    "& div": {
      display: "flex",
      justifyContent: "flex-end",
      "& a": {
        display: "flex",
        alignItems: "center",
        gap: 4,
        lineHeight: "21px",
        color: theme.palette.primary.main,
        "& svg": {
          "& path": {
            stroke: theme.palette.primary.main,
          },
        },
      },
    },
  },
  header_popover_user: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    "& div": {
      height: 62,
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: "8px 16px",
      minWidth: 160,
      "& strong": {
        color: theme.palette.text[100],
        fontSize: 16,
        lineHeight: "24px",
        cursor: "pointer",
      },
      "& span": {
        color: theme.palette.text[60],
      },
    },
    "& a": {
      display: "flex",
      gap: 10,
      alignItems: "center",
      height: 56,
      padding: 16,
      color: theme.palette.text[100],
      "& strong": {
        fontSize: 16,
        fontWeight: 500,
        color: theme.palette.text[100],
        lineHeight: "24px",
        "& span": {
          display: "flex",
          alignItems: "center",
          gap: 4,
          padding: "0 8px",
          height: 22,
          background: theme.palette.grey[5],
          borderRadius: 22,
          lineHeight: "18px",
          color: theme.palette.text[60],
          fontSize: 12,
          margin: "6px 0 0",
        },
      },
      "&:hover": {
        background: theme.palette.grey[5],
        borderRadius: 4,
      },
    },
  },
  header_popover_con: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 500,
    "& a": {
      height: 56,
      color: theme.palette.text[100],
      display: "flex",
      alignItems: "center",
      padding: "0 16px",
      fontSize: 16,
      borderRadius: 6,
      marginBottom: 10,
      whiteSpace: "nowrap",
      minWidth: 160,
      "&:hover": {
        background: theme.palette.grey[5],
        // color: theme.palette.primary.main,
      },
      svg: {
        width: 24,
        height: 24,
        marginRight: 10,
      },
      "&:last-of-type": {
        marginBottom: 0,
      },
    },
  },
  menu: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text[100],
    gap: 24,
    "& a": {
      color: theme.palette.text[100],
      "&.on,&:hover": {
        color: theme.palette.primary.main,
      },
      "& strong": {
        fontWeight: 500,
      },
    },
    "@media screen and (max-width:1440px)": {
      gap: 20,
    },
  },
  muilt_menu: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    color: theme.palette.text[100],
    "& strong": {
      lineHeight: "24px",
    },
    "& svg": {
      transition: "all .3s ease-in-out",
    },

    "&:hover,&.on": {
      color: theme.palette.primary.main,
      "& svg": {
        transform: "rotateZ(180deg)",
        "& path": {
          fill: theme.palette.primary.main,
        },
      },
    },
  },
  layer: {},
  quick_c2c: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 8,
    "& .item": {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: 16,
      justifyContent: "space-between",
      width: 320,
      cursor: "pointer",
      "&:hover": {
        background: theme.palette.grey[5],
        "& span": {
          "& svg": {
            display: "block",
          },
        },
      },
      "& span": {
        height: 24,
        display: "flex",
        width: 24,
        "& svg": {
          display: "none",
        },
      },
      "& div": {
        flex: 1,
        "& strong": {
          fontSize: 14,
          fontWeight: 500,
          color: theme.palette.text[100],
          lineHeight: "21px",
        },
        "& p": {
          fontSize: 12,
          fontWeight: 400,
          color: theme.palette.text[100],
          lineHeight: "18px",
        },
      },
      img: {
        width: 36,
        height: 36,
      },
    },
  },
  badge_dot: {
    background: "red",
    minWidth: 6,
    height: 6,
  },
  custommenu: {
    position: "fixed",
    zIndex: 600,
    right: 38,
    bottom: 35,
    height: 48,
    width: 48,
    borderRadius: 48,
    background: theme.palette.primary.main,
    color: "#F2F6F9",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all .3s ease-in-out",
    display: "flex",
    flexDirection: "row-reverse",
    "& .con": {
      height: 48,
      width: "calc(48px + 48px + 48px)",
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
    },
    "& .item": {
      flexBasis: 48,
      width: 48,
      height: 48,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#F2F6F9",
      transition: "all .3s ease-in-out",
      "&:hover": {
        color: "#fff",
        "& svg": {
          opacity: 1,
        },
      },
    },
    "& svg": {
      opacity: 0.7,
      transition: "all .3s ease-in-out",
    },
    "&:hover": {
      width: "calc(48px + 48px + 48px)",
    },
  },
  menu_popover: {
    padding: 12,
    whiteSpace: "nowrap",
    maxHeight: 500,
    overflow: "auto",
    "-ms-overflow-style": "none" /* 对于IE和Edge */,
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  menu2: {
    fontWeight: 500,
    minWidth: 160,
    "& li": {
      fontSize: 14,
      lineHeight: "40px",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      borderRadius: 6,
      cursor: "pointer",
      "&:hover": {
        background: theme.palette.grey[5],
      },
    },
    "& a": {
      color: theme.palette.text[100],
    },
    "& .sub": {
      fontSize: 14,
      lineHeight: "40px",
      padding: "0 16px",
      borderRadius: 6,
      "&:hover": {
        background: theme.palette.grey[5],
      },
    },
  },
});
